export const discussions = [
  {
    id: "d-001",
    topicId: "film-dajieju-lanwei",
    topicTitle: "剧集大结局引热议：开放式结局到底算不算烂尾",
    author: "追更到凌晨三点",
    stance: "质疑",
    content:
      "我能接受留白，但不能接受三条支线一条都不收。开放式结局的前提是主线已经闭环，这里明显没有。把没写完说成高级，对认真追了三个月的观众不太公平。",
    likes: 1284,
    replies: 96,
    time: "2 小时前",
    badges: ["高赞观点", "老用户"],
  },
  {
    id: "d-002",
    topicId: "film-dajieju-lanwei",
    topicTitle: "剧集大结局引热议：开放式结局到底算不算烂尾",
    author: "慢慢看剧的人",
    stance: "支持",
    content:
      "最后一集我看了两遍。人物关系其实已经完成了，主角推开门那一下，是整部剧唯一一次不解释的选择。我喜欢这种不把话说满的处理，它让我在关掉播放器之后还在想。",
    likes: 976,
    replies: 64,
    time: "5 小时前",
    badges: ["观点交锋"],
  },
  {
    id: "d-003",
    topicId: "variety-mingchangmian-2026",
    topicTitle: "年度综艺名场面盘点：这届观众为何集体破防",
    author: "弹幕考古学家",
    stance: "中立",
    content:
      "名场面是观众和节目一起完成的。同一段素材，放在不同的剪辑结构里，情绪强度完全不同。与其争论有没有剧本，不如承认我们都在参与一场共同创作。",
    likes: 842,
    replies: 51,
    time: "8 小时前",
    badges: ["编辑推荐"],
  },
  {
    id: "d-004",
    topicId: "star-gongzuoshi-huiying",
    topicTitle: "工作室回应越来越模板化，网友：能不能有点诚意",
    author: "只讲道理不吵架",
    stance: "质疑",
    content:
      "模板本身不是原罪，问题是所有回应都回避了最核心的那个问题。公众其实很宽容，只要有一句是正面回答的，剩下的部分大家都能理解。",
    likes: 1567,
    replies: 142,
    time: "昨天",
    badges: ["热门讨论", "高赞观点"],
  },
  {
    id: "d-005",
    topicId: "concert-yingyuan-neijuan",
    topicTitle: "演唱会应援卷出新高度：荧光棒还是应援服",
    author: "第三排靠过道",
    stance: "中立",
    content:
      "应援没错，但别把参与感变成考核指标。我去现场就是想把歌唱完，荧光棒颜色不对不影响我听歌。希望志愿者能理解，不是每个人都想加入那场仪式。",
    likes: 1103,
    replies: 88,
    time: "昨天",
    badges: ["高赞观点"],
  },
  {
    id: "d-006",
    topicId: "industry-duanju-nengreng-jiu",
    topicTitle: "短剧爆火之后：三分钟一集的快乐能持续多久",
    author: "刷剧不打盹",
    stance: "支持",
    content:
      "短剧救了我的通勤时间。不是所有内容都要有深度，能让人在拥挤的地铁上笑三分钟，就已经完成了它的使命。要求短剧承担长剧的责任，本身就是错位。",
    likes: 734,
    replies: 73,
    time: "2 天前",
    badges: ["观点交锋"],
  },
  {
    id: "d-007",
    topicId: "variety-jianji-zhengyi",
    topicTitle: "综艺剪辑争议：镜头分配背后到底有没有玄机",
    author: "后期小透明",
    stance: "中立",
    content:
      "作为从业者说一句：一档综艺的素材量是成片的几十倍，取舍是必然的。但取舍的标准如果每次都只服务于热度，那观众迟早会看出来。专业和套路只差一条线。",
    likes: 1320,
    replies: 109,
    time: "3 天前",
    badges: ["专业人士", "高赞观点"],
  },
  {
    id: "d-008",
    topicId: "music-yinyuejie-chuanda",
    topicTitle: "音乐节穿搭大赏：从野餐风到机能风的审美迁移",
    author: "草坪上的摄影师",
    stance: "支持",
    content:
      "机能风真的更好拍吗？其实不是，是更好活。站一天、下雨、降温、泥地，这些才是现场的真实条件。审美跟着功能走，我觉得这反而是成熟的标志。",
    likes: 615,
    replies: 38,
    time: "3 天前",
    badges: [],
  },
  {
    id: "d-009",
    topicId: "film-guzhuang-zaoxing",
    topicTitle: "古装剧造型同质化，观众的审美疲劳到哪一步了",
    author: "考据使我快乐",
    stance: "质疑",
    content:
      "同质化的根源是风险评估机制。一套方案被验证过，所有人就都用它。但观众的记忆是靠差异建立的，全都一样，等于全都没有留下印象。",
    likes: 887,
    replies: 62,
    time: "4 天前",
    badges: ["编辑推荐"],
  },
  {
    id: "d-010",
    topicId: "meme-biaoqingbao-chuandi",
    topicTitle: "网络热梗是怎么火起来的：一个表情包的完整传播路径",
    author: "梗用多了会腻",
    stance: "中立",
    content:
      "说梗过气的人，往往是自己用得太早了。一个梗从圈层符号变成公共词汇，本来就是它在扩散的证据。真正可惜的是那些被过度解释的梗，一解释就不好笑了。",
    likes: 691,
    replies: 54,
    time: "4 天前",
    badges: [],
  },
];